import React, { useEffect, useRef, useState } from 'react';
import { MyEmitter } from '../../../events';
import { FaTimes } from 'react-icons/fa';

import ColorPicker from '../../common/color-picker/ColorPicker';
import { deleteNode, updateNode } from '../../../services/board/board';
import { useCurrentBoard } from '../../../services/state';

import './UpdateCircle.css';
import '../../../App.css';

const dialogWidth = 300;
const dialogHeight = 365;
const headerHeightInPx = 70;

const UpdateCircle = () => {
  const [nodeState, setNodeState] = useState({
    parentId: '',
    background: '',
    role: 'circle'
  });
  const [title, setTitle] = useState('');
  const [color, setColor] = useState('#2EAAEA');
  const [updateFields, setUpdateFields] = useState({});
  const [{ top, left }, setPosition] = useState({ top: '-1000px', left: 0 });
  const modalRef = useRef(null);
  const titleInputRef = useRef(null);

  const { moveWithChildren, editedNodeId } = useCurrentBoard();

  useEffect(() => {
    const graph = document.getElementById('tree');
    if (graph) {
      graph.addEventListener('mousedown', handleClick, false);
    }

    MyEmitter.subscribe('circleChange', data => {
      const position = calcPosition();

      setUpdateFields([]);
      setNodeState({
        parentId: data.parentId,
        role: data.role,
        background: data.background
      });
      setTitle(data.title);
      setColor(data.color);
      setPosition(position);
      titleInputRef.current.focus();
    });

    return () => {
      const graph = document.getElementById('tree');
      if (graph) {
        graph.removeEventListener('mousedown', handleClick, false);
      }
    };
  }, []);

  const handleClick = e => {
    //e.stopPropagation();
    if (modalRef.current && modalRef.current.contains(e.target)) {
      return;
    } else {
      toggleChangeForm();
    }
  };

  const fitBetweenLimits = ({ value, min, max }) => {
    if (value < min) return min;
    if (value > max) return max;
    return value;
  };

  const calcPosition = () => {
    const eventX = window.event.clientX;
    const eventY = window.event.clientY;

    const left = eventX - dialogWidth / 2;
    const leftMax = window.innerWidth - dialogWidth;

    const top = eventY - dialogHeight / 2;
    const topMax = window.innerHeight - dialogHeight;

    return {
      left: fitBetweenLimits({ value: left, min: 0, max: leftMax }),
      top: fitBetweenLimits({ value: top, min: headerHeightInPx, max: topMax })
    };
  };

  const handleColorChange = color => {
    setColor(color);
    setUpdateFields({ ...updateFields, color });
  };

  const handleChangeInput = e => {
    e.preventDefault();

    setTitle(e.target.value);
    setUpdateFields({ ...updateFields, title: e.target.value });
  };

  const handleSubmit = e => {
    e.preventDefault();
    updateNode(editedNodeId, updateFields);
    toggleChangeForm();
  };

  const handleDelete = e => {
    e.preventDefault();

    deleteNode({ nodeId: editedNodeId, withChildren: moveWithChildren });
    toggleChangeForm();
  };

  const toggleChangeForm = () => {
    setPosition({ left, top: '-1000px' });
    return false;
  };

  //	const d="M "+cx+","+cy+"  m "+(r)+", 0 a "+r+","+r+" 0 "+ flag1+","+flag2+" "+(-2*r)+",0 a "+r+","+r+" 0 "+flag1+","+flag2+" "+(2*r)+",0";
  return (
    <div
      tabIndex={-1}
      style={{ position: 'absolute', left: left, top: top, outline: 'none' }}
      ref={modalRef}
      onKeyDown={event => {
        if (event.key === 'Enter') {
          handleSubmit(event);
        }
        if (event.key === 'Escape') {
          toggleChangeForm();
        }
      }}
    >
      <div className="ChangeCircle m-2 text-left position-relative">
        <div className="position-absolute closeBtn" onClick={toggleChangeForm}>
          <FaTimes />
        </div>
        <div className="d-flex justify-content-center text-center example-wrapper">
          <div>
            <ColorPicker onChange={handleColorChange} color={color} />
            {nodeState.role === 'circle' && (
              <div
                className="example circleExample d-flex flex-column justify-content-center"
                style={{ backgroundColor: color, color: '#fff' }}
              >
                <svg
                  className="svg exampleSvg"
                  width="200px"
                  height="200px"
                  viewBox="0 0 200 200"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g>
                    <circle
                      r="100"
                      cx="100"
                      cy="100"
                      fill={color}
                      strokeWidth="3"
                      stroke={color}
                    ></circle>
                    {nodeState.background !== '' && (
                      <foreignObject x="1" y="1" width="198" height="198">
                        <div
                          className="objectfit"
                          style={{
                            backgroundImage: `url(${nodeState.background})`
                          }}
                        />
                      </foreignObject>
                    )}

                    <foreignObject x="5" y="80" width="190" height="100">
                      <div>
                        <input
                          ref={titleInputRef}
                          name="nameInput"
                          aria-label="circle title"
                          className="input w-100 mb-0 text-center"
                          type="text"
                          value={title}
                          placeholder="click here and type"
                          onChange={handleChangeInput}
                        />
                      </div>
                    </foreignObject>
                  </g>
                </svg>
              </div>
            )}
            {nodeState.role === 'group' && (
              <div className="example d-flex flex-column justify-content-center">
                <svg
                  className="svg exampleSvg"
                  width="200px"
                  height="200px"
                  viewBox="0 0 200 200"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g>
                    <circle
                      r="100"
                      cx="100"
                      cy="100"
                      fill="transparent"
                      strokeWidth="3"
                      stroke={color}
                    ></circle>
                    {/*<text x="0" y="0" textAnchor="middle" style={{ fill:'#fff', stroke:'none'}}><textPath xlinkHref="#tophalf" startOffset="50%">{state.title !== '' ? state.title : 'choose name'}</textPath></text> */}
                    <foreignObject x="5" y="80" width="190" height="100">
                      <div>
                        <input
                          ref={titleInputRef}
                          className="input w-100 mb-0 text-center"
                          type="text"
                          value={title}
                          placeholder="click here and type"
                          onChange={handleChangeInput}
                        />
                      </div>
                    </foreignObject>
                  </g>
                </svg>
              </div>
            )}
          </div>
        </div>

        <div className="text-center btn-cta-wrapper m-t-1">
          <button className="btn btn-primary m-r-2 p-x-2" aria-label="Save" onClick={handleSubmit}>
            Save
          </button>
          <button className="btn btn-secondary" aria-label="Delete" onClick={handleDelete}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateCircle;
